<template>
  <div class="footer-cookies">
    <div
      class="footer-cookies__content"
    >
      <div class="footer-cookies__content__text">
        <p>
          {{ $t('cookies_1') }}
        </p>
      </div>
      <div class="footer-cookies__content__buttons">
        <div
          class="footer-cookies__content__buttons __button"
          @click="openDetails"
        >
          <button-view variant="full">
            {{ $t('cookies_2') }}
          </button-view>
        </div>
        <div
          class="footer-cookies__content__buttons __button"
          @click="saveCookies"
        >
          <button-view variant="secondary full">
            {{ $t('cookies_3') }}
          </button-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as cookie from '@/utils/cookies';

export default {
  name: 'FooterCookies',

  components: {
    ButtonView: () => import('@/components/button/button-view')
  },
  data() {
    return {
      cookie: cookie
    };
  },

  methods: {
    openDetails() {
      this.$emit('openDetails');
    },

    saveCookies() {
      this.$emit('closeFooter');
      this.cookie.setCookie('cookies-bliss', 'All-Cookies');
      this.cookie.setInCookies();
      this.cookie.setGaCookies(false);
    }
  }

};
</script>

<style lang="scss" src="@/assets/components/footer/footer-cookies-view.scss"></style>



// WEBPACK FOOTER //
// footer-cookies-view.vue